import type {Me} from "../types";

type MeHouseholdEmbed = {
  id?: number;
  house_hold_id?: number;
  name?: string;
};

/** Resolves household id from `/me` shapes (`house_hold_id` or nested `house_hold.id`). */
export function getMeHouseholdId(
  me: Pick<Me, "house_hold_id"> & {house_hold?: MeHouseholdEmbed | null},
): number | null {
  if (me.house_hold_id != null && me.house_hold_id !== 0) {
    return me.house_hold_id;
  }
  const fromEmbed = me.house_hold?.id ?? me.house_hold?.house_hold_id;
  if (fromEmbed != null && fromEmbed !== 0) return fromEmbed;
  return null;
}
